import { ChangeDetectionStrategy, Component, contentChildren, Input } from '@angular/core';

import { SlotDirective } from '@directive';

@Component({
  selector: 'spa-detail-area',
  templateUrl: './detail-area.component.html',
  styleUrls: ['./detail-area.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailAreaComponent<T> {
  @Input() details: Details<T>[] = [];
  @Input() element: T | undefined;
  contentTemplate = contentChildren(SlotDirective);

  getText(data: TextAndStyling<T>): string {
    if (data.textByFunction && this.element !== undefined) {
      return data.textByFunction(this.element);
    }
    return '';
  }
}
export interface Details<T> {
  headline?: string;
  sectionTitle?: string;
  label?: string;
  data?: TextAndStyling<T>;
  html?: string;
}

export interface TextAndStyling<T> {
  text?: string;
  textByFunction?: (element: T) => string;
  styling?: unknown;
}
